// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pHni","label":"styles_label__miyU-"};